import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../../@types/RootState';

type State = {
  PAN: boolean;
  COL: boolean;
  IPA: boolean;
  SDD: boolean;
  none: boolean;
  MONITOR: boolean;
};

export type NavBarModalKeys = keyof State;

const initialState: State = {
  PAN: false,
  COL: false,
  IPA: false,
  SDD: false,
  none: false,
  MONITOR: false,
};

export type SetIsOpenPayload = {
  key: NavBarModalKeys;
  payload: boolean;
};

const slice = createSlice({
  name: 'navBar.modals',
  initialState,
  reducers: {
    SET_IS_OPEN: (state, action: PayloadAction<SetIsOpenPayload>) => {
      state[action.payload.key] = action.payload.payload;
    },
  },
});

export const { SET_IS_OPEN } = slice.actions;

export default slice.reducer;

export const selectorNavBarModals = (state: RootState): State => {
  return state.navBar.modals;
};
